import React, { useState, useEffect } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import "../../common.css";
import "../../investorAcademy.css";
import ChildInvestorAcademyCommon from '../../../../../components/common/InvestorAcademyCommon/ChildInvestorAcademyCommon';
import SelectingWarrantCommonTabs from '../../../../../components/common/SelectingWarrantCommonTabs';
import SelectingWarrentImg from '../../../../../components/common/SelectingWarrentImg';



const SelectingWarrants = (props) => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    const location = useLocation();
    const history = useHistory();
    const [openLive, setOpenLive] = useState(false);
    const [imageUrl, setImageUrl] = useState("");

    return (
        <div id="investor_academy">
            <div className="imgbg" />
            <div className="mainbg"></div>

            <div id="main">
                <div id="maintable" className='select_warrent Common_warrent' style={{ display: 'table', width: '100%', tableLayout: 'fixed' }}>
                    <div style={{ display: 'table-row' }}>
                        <div id="leftbar" className="hidden-xs" style={{ display: 'table-cell', width: '80px' }} />
                        <div id="maincontainer" style={{ display: 'table-cell', width: '100%' }}>
                            <div id="mainnav">
                                <table style={{ width: '100%', tableLayout: 'fixed', borderBottom: '1px solid #353223' }}>
                                    <tbody><tr>
                                        <td width="20%" style={{ textAlign: 'left', visibility: 'hidden' }}>
                                            <table className="hasprev hidden-xs" style={{ width: '100%', height: '100%', tableLayout: 'fixed' }}>
                                                <tbody><tr>
                                                    <td width="33px"><div className="prev left" /></td>
                                                    <td>
                                                        <div className="prevlbl left">
                                                            <div className="prevtitle " style={{ textAlign: 'left' }}>Previous Topic</div>
                                                            <div className="prevname " style={{ textAlign: 'left' }}>How to select a Warrant?</div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                </tbody></table>
                                        </td>
                                        <td width="60%" style={{ textAlign: 'center' }}>
                                            <div id="pagetitlediv" style={{ width: '365px', height: '100%', borderBottom: '1px solid rgb(255, 216, 67)', margin: 'auto' }}>
                                                <div id="ptitle" style={{ fontFamily: 'HelveticaNeueThinCond', fontSize: '25px', color: 'white', letterSpacing: '1px' }}>How to select a Warrant?</div>
                                                <div id="pname" style={{ fontFamily: 'HelveticaNeueThinCond', fontSize: '30px', color: '#FFD843', letterSpacing: '1px', paddingTop: '5px', paddingBottom: '5px' }} />
                                            </div>
                                        </td>
                                        <td width="20%" style={{ textAlign: 'right', visibility: 'hidden' }}>
                                            <table className="hasnext  hidden-xs" style={{ width: '100%', height: '100%', tableLayout: 'fixed' }}>
                                                <tbody><tr>
                                                    <td>
                                                        <div className="nextlbl right">
                                                            <div className="nexttitle " style={{ textAlign: 'right' }} />
                                                            <div className="nextname " style={{ textAlign: 'right' }}>Timeframe </div>
                                                        </div>
                                                    </td>
                                                    <td width="33px"><div className="next right" /></td>
                                                </tr>
                                                </tbody></table>
                                        </td>
                                    </tr>
                                    </tbody></table>
                            </div>
                            <div id="maincontent" style={{ marginLeft: '10px', marginRight: '10px', paddingTop: '40px', marginBottom: '60px' }}>
                                <div id="mainscroll" style={{ height: '100%', overflowX: 'hidden', overflowY: 'auto', paddingLeft: '90px', paddingRight: '90px' }}>
                                    <div id="mainscrollcontent">
                                        <style dangerouslySetInnerHTML={{ __html: "\n            .contentbox table thead th{\n                background-color: #FFD400;\n            }\n            .contentbox table tbody td,\n            .contentbox table thead th{\n                padding:0.5em 1em;\n                color:#000000;\n                text-align: center;\n            }\n            .contentbox table tbody td.bgc0{\n                background-color: #FFF4D2;\n            }\n            .contentbox table thead th.bgc1 {\n                background-color: #9E9FA1;\n            }\n            .contentbox table tbody td.bgc2{\n                background-color: #C0C1C2;\n            }\n            .contentbox table tbody tr.active td{\n                background-color: #FD8C8F;\n            }\n/*            .imgholder img{\n                max-width: 894px;\n            }*/\n            .ms .contentbox table.ctable\n            .xs .contentbox table.ctable,\n            .xxs .contentbox table.ctable{\n               font-size:11px;\n            }\n            .ms .contentbox table  td,\n            .ms .contentbox table  th,\n            .xs .contentbox table  td,\n            .xs .contentbox table  th,\n            .xxs .contentbox table td,\n            .xxs .contentbox table th{\n                padding:0.5em;\n            }\n            .imgholder .imgmask{\n                position:relative;\n                margin:auto;\n            }\n            .imgholder .area{\n                position:absolute;\n                display:block;\n            }\n        " }} />
                                        <div className="contentbox">
                                            <p>When choosing a warrant, we suggest that investors consider the following 4 steps. Click on any of the steps below to view more information, or use the arrows located at the bottom left and right-hand side of the window to navigate.</p>

                                            <div className="imgholder">

                                                <SelectingWarrantCommonTabs Location={location} Hist={history} />

                                                {/* <div className="imgmask" style={{maxWidth: '800px'}}>
                                     <img src='/img/education/fourstep0.png' style={{maxWidth: '800px'}} alt="image" />
                                        <a href='#'
                                         className="area" style={{top: '10%', left: '0%', width: '25%', height: '70%'}}  />

                                        <a className="area" style={{top: '10%', left: '26%', width: '24%', height: '70%'}} href="#" />
                                        <a className="area" style={{top: '10%', left: '50%', width: '24%', height: '70%'}} href="#" />
                                        <a className="area" style={{top: '10%', left: '75%', width: '24%', height: '70%'}} href="#" />
                                    </div> */}
                                            </div>

                                            <p>
                                                Before we begin, you should first look at the nature and performance of the underlying share/index and take a view. Bullish investors may consider a call warrant while bearish investors may consider a put warrant.<br /><br />
                                            </p>
                                            <div className="imgholder">
                                                <img src='/img/education/bullBear.png' style={{ maxWidth: '200px' }} alt="image" />
                                            </div>
                                            <p>
                                                You also need to have a target price for the stock in mind. This will help you to narrow your selection of the warrants.
                                            </p>
                                            <div className="imgholder">
                                                <img src='/img/education/viewonunderlyingshareindex.png' style={{ maxWidth: '841px' }} />
                                                <div className="map_pop">
                                                    <div
                                                        className="how_put"
                                                        data-bs-toggle="collapse"
                                                        href="#popup-image"
                                                        role="text"
                                                        aria-expanded="false"
                                                        aria-controls="popup-image"
                                                        onClick={() => { return setOpenLive(true), setImageUrl("/img/education/viewonunderlyingshareindexMob.png") }}
                                                    >View table
                                                    </div>
                                                </div>


                                            </div>
                                            <h2>
                                                Are you bullish (call) or bearish (put)?
                                            </h2>
                                            <p>If you are bullish on the underlying, you should eliminate put warrants from your consideration.</p>
                                            <div className="imgholder">
                                                <img src='/img/education/table0.png' style={{ maxWidth: '889px' }} alt="image" />
                                                <div className="map_pop">
                                                    <div
                                                        className="how_put"
                                                        data-bs-toggle="collapse"
                                                        href="#popup-image"
                                                        role="text"
                                                        aria-expanded="false"
                                                        aria-controls="popup-image"
                                                        onClick={() => { return setOpenLive(true), setImageUrl("/img/education/tablemMob.png") }}
                                                    >View table
                                                    </div>
                                                </div>


                                            </div>
                                            <p>
                                                Continue to narrow down the warrant selection based on timeframe  by clicking <Link to="/edu/select-warrant/selecting-warrant/time-frame">here</Link> or by selecting any one of the four steps above.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div id="rightbar" className="hidden-xs" style={{ display: 'table-cell', width: '80px' }}>
                                </div>
                            </div>
                        </div>
                        <div id="rightbar" className="hidden-xs" style={{ display: 'table-cell', width: '80px' }}>
                        </div>
                    </div>
                </div>
            </div>

            <div
                id="bottom"
                style={{
                    position: "fixed",
                    width: "100%",
                    bottom: "0px",
                    height: "40px",
                    backgroundColor: "#101010",
                    zIndex: 10000,
                }}
            >
                <div
                    className="hidden-xs hidden-xxs"
                    style={{
                        display: "table",
                        width: "100%",
                        textAlign: "center",
                        color: "#8F8F8F",
                        fontSize: "11px",
                        lineHeight: "40px",
                    }}
                >
                    <div className='copyright_sec'>
                        Copyright (c) 2016 Macquarie Group Limited ABN 94 122 169 279. All rights
                        reserved.
                    </div>
                </div>
                <div
                    style={{
                        position: "absolute",
                        width: "46%",
                        height: "35px",
                        right: "10px",
                        bottom: "5px",
                    }}
                >
                    <table
                        className="hasnext"
                        style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                        <tbody>
                            <tr>
                                <td>
                                    <div className="nextlbl right">
                                        <div
                                            className="nextname "
                                            style={{ textAlign: "right", fontSize: "15px" }}
                                        >
                                            <Link to="/edu/select-warrant/selecting-warrant/time-frame">
                                                <span className="prevname ">Timeframe</span>
                                            </Link>
                                        </div>
                                    </div>
                                </td>
                                <td width="33px">
                                    <Link to="/edu/select-warrant/selecting-warrant/time-frame">
                                        <div className="next right" />
                                    </Link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div
                    style={{
                        position: "absolute",
                        width: "46%",
                        height: "35px",
                        left: "10px",
                        bottom: "5px",
                    }}
                >
                    <table
                        className="hasprev"
                        style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                        <tbody>
                            <tr>
                                <td width="33px">
                                    <Link to="/edu/select-warrant">
                                        <div className="prev left" />
                                    </Link>
                                </td>
                                <td>
                                    <div className="prevlbl left">
                                        <div
                                            className="prevname "
                                            style={{ textAlign: "left", fontSize: "15px" }}
                                        >
                                            <Link to="/edu/select-warrant">
                                                <span className="prevname ">How to select a Warrant?</span>
                                            </Link>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <SelectingWarrentImg Open={openLive} OpenModel={() => setOpenLive(!true)} Data={imageUrl} />
            <div id="dotbar" className="hidden-sm hidden-xs" style={{}}>
                {/* <div className="dbtn dbtn-seminarbtn">
                    <Link
                        className="seminarbtn"
                        to="/education/seminar"
                    >
                        <img src='/img/education/button-static.png' alt="image" />
                    </Link>
                </div> */}

                <ChildInvestorAcademyCommon Location={location} Hist={history} />
            </div>

        </div>
    );
}
export default SelectingWarrants;